import { ADMISSIONID } from '../../Constants/SettingsConstants'

const admissionIdReducer = (state = {}, action: { type: any, data: any }) => {
  switch (action.type) {
    case ADMISSIONID:
      return action.data
    default: return state
  }
}

export default admissionIdReducer
